import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Form, Select } from "antd";
import { useFormTcfVendor } from "../../../../../contexts/formTcfVendor.js";
import { useI18n } from "../../../../../contexts/i18n.js";
const FormTcfVendorFieldGeneralDataProcessingInCountries = ()=>{
    const { __ } = useI18n();
    const { iso3166OneAlpha2 } = useFormTcfVendor();
    return /*#__PURE__*/ _jsxs(Form.Item, {
        label: __("Data processing in countries"),
        children: [
            /*#__PURE__*/ _jsx(Form.Item, {
                name: "dataProcessingInCountries",
                noStyle: true,
                children: /*#__PURE__*/ _jsx(Select, {
                    mode: "multiple",
                    showSearch: true,
                    optionFilterProp: "children",
                    maxTagCount: "responsive",
                    children: Object.keys(iso3166OneAlpha2).map((code)=>/*#__PURE__*/ _jsx(Select.Option, {
                            value: code,
                            children: iso3166OneAlpha2[code]
                        }, code))
                })
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "description",
                children: __("Data is usually processed in the countries where the vendor has its headquarter or servers. You should check with your service provider where your users' data is processed.")
            })
        ]
    });
};
export { FormTcfVendorFieldGeneralDataProcessingInCountries };
